import {
  ILicensesOverviewParams,
  LicenseApiType,
  LicensesSortOrder,
} from "~/entity/Licenses/model/schema";

export const mapLicenseTypeToApi = (
  licenseType?: string,
): LicenseApiType | undefined => {
  if (licenseType === "basic") {
    return "BASE";
  }

  if (licenseType === "additional") {
    return "ADDITIONAL";
  }

  return undefined;
};

export const LICENSES_ORGANIZATION_SORT_TO_API: Record<string, string> = {
  inn: "inn",
  branchCode: "branchCode",
  organizationName: "name",
  totalQuantity: "total",
  assignedQuantity: "assigned",
  frozenQuantity: "frozen",
  freeQuantity: "available",
  expiredQuantity: "expired",
};

export const LICENSES_POSITION_SORT_TO_API: Record<string, string> = {
  positionName: "method",
  totalQuantity: "total",
  assignedQuantity: "assigned",
  frozenQuantity: "frozen",
  freeQuantity: "available",
  expiredQuantity: "expired",
};

export const LICENSES_EMPLOYEE_SORT_TO_API: Record<string, string> = {
  employeeId: "employeeId",
  employeeName: "employeeName",
  position: "positionName",
  email: "employeeEmail",
  tariffType: "licenseType",
  licenseCost: "price",
  status: "status",
};

export const mapLicensesSortToQuery = (
  sortField?: string,
  sortType?: string,
  fieldMap: Record<string, string> = LICENSES_ORGANIZATION_SORT_TO_API,
): Pick<ILicensesOverviewParams, "sortBy" | "sortOrder"> => {
  const sortBy = sortField ? fieldMap[sortField] : undefined;

  if (!sortBy || (sortType !== "ASC" && sortType !== "DESC")) {
    return {};
  }

  return {
    sortBy,
    sortOrder: sortType.toLowerCase() as LicensesSortOrder,
  };
};
